var Handlebars = require("../../template.thomasjacob.de/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "		<i class=\"fa fa-check\"></i>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,__default(require("./handlebars/eq.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"error",{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":4,"column":11},"end":{"line":4,"column":28}}}),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":1},"end":{"line":6,"column":1}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    return "		<i class=\"fa fa-exclamation-triangle\"></i>\n	";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p class=\"message message--"
    + container.escapeExpression(alias1((depth0 != null ? lookupProperty(depth0,"type") : depth0), depth0))
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,__default(require("./handlebars/eq.js")).call(alias2,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"ok",{"name":"eq","hash":{},"data":data,"loc":{"start":{"line":2,"column":7},"end":{"line":2,"column":21}}}),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":1},"end":{"line":6,"column":8}}})) != null ? stack1 : "")
    + "	<span>"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"message") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\n</p>";
},"useData":true});